import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const StoriesListContainer = styled.div`
  display: grid;
  row-gap: 4rem;
  column-gap: 2rem;
  max-width: 1220px !important;
  width: calc(100vw - 3rem);
  grid-template-columns: 1fr 1fr 1fr;
  padding-bottom: 5rem;

  a {
    text-decoration: none;
    color: ${palette.text};
    display: grid;
  }

  @media all and (max-width: ${layout.sm}) {
    grid-template-columns: 1fr;
    padding-bottom: 1rem;
  }
`;

export const StoryEntry = styled.div`
  border: solid 1px ${palette.fog};
  background-color: ${palette.white};
  transition: all .2s ease;

  &:hover {
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, .2);
    color: ${palette.snowFlower};
  }
`;

export const StoryEntryEmpty = styled(StoryEntry)`
  display: grid;

  p {
    max-width: 73px;
    justify-self: center;
  }

  &:hover {
    box-shadow: none;
    color: inherit;
  }
`;

export const StoryEmptyText = styled.div`
  align-self: center;
  justify-self: center;
  grid-template-rows: 35px 1fr 35px;
  display: grid;
  row-gap: 35px;

  svg {
    height: 35px;
    justify-self: center;
  }

  @media all and (max-width: ${layout.sm}) {
    row-gap: 24px;
  }
`;

export const StoryImage = styled.div`
  overflow: hidden;
  height: 255px;

  & > div {
    height: 100%;
  }
`;

export const StoryTitle = styled.div`
  padding: 24px;
`;
